export const SECTION_STATUS = {
    NEW: 'New',
    COMPLETED: 'Completed',
    IN_PROGRESS: 'InProgress',
    REFRESHER: 'Refresher',
    DISABLED: 'Disabled',
    FAILED: 'Failed',
    RESTARTED: 'Restarted',
};

export const TASK_STATUS = {
    NOT_STARTED: 'NotStarted',
    PENDING: 'Pending',
    PENDING_EXEMPTION: 'PendingExemption',
    RECALLED: 'Recalled',
    RECALLED_AFTER_SIGN_OFF: 'RecalledAfterSignOff',
    REDO_REQUIRED: 'RedoRequired',
    CLOSED: 'Closed',
    EXEMPTED: 'Exempted',
} as const;

export const PATHWAY_MENU_TYPES = {
    VIDEO: 'Video',
    YOUTUBE: 'YouTube',
    PDF: 'PDF',
    QUIZ: 'Quiz',
    FINAL_QUIZ: 'FinalQuiz',
    ADAPTIVE_QUIZ: 'AdaptiveQuiz',
    SURVEY: 'Survey',
    TASK: 'Task',
};

export const SELECTED_CLASSNAME = 'selected-item';

export const SELECTED_CLASSNAME_OVERVIEW = 'overview-selected-item';

export const REVIEW_SUGGESTED_CLASSNAME = 'review-suggested';

export const SECTION_CIRCLE = true;
